"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _featureDetection = require("js-utils/feature-detection");

var _NotificationBar = _interopRequireDefault(require("eventbrite_design_system/notification/NotificationBar"));

var _constants = require("eventbrite_design_system/notification/constants");

var _dom = require("eventbrite_design_system/utils/dom");

var _Check = _interopRequireDefault(require("eventbrite_design_system/iconography/icons/Check"));

var _AlertChunky = _interopRequireDefault(require("eventbrite_design_system/iconography/icons/AlertChunky"));

var _withNotificationControls = _interopRequireDefault(require("../HOC/withNotificationControls"));

var _constants2 = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NOTIFICATION_BOUNCE_INTERVAL = 50;

var SuccessNotificationBarContent = function SuccessNotificationBarContent(_ref) {
  var name = _ref.name;
  //Need to set dangerousInnterHTML because there is markup in the translated string,
  //which would otherwise be encoded. No user controlled data is coming to this function
  //so is quite safe.
  var dangerousContent = (0, _constants2.getSuccessNotificationText)(name);
  return /*#__PURE__*/_react.default.createElement(NotificationBarContent, {
    dangerousContent: dangerousContent
  });
};

var ErrorNotificationBarContent = function ErrorNotificationBarContent(_ref2) {
  var _ERROR_ACTION_MAP;

  var name = _ref2.name,
      errorActionType = _ref2.errorActionType;
  var ERROR_ACTION_MAP = (_ERROR_ACTION_MAP = {}, _defineProperty(_ERROR_ACTION_MAP, _constants2.ERROR_FOLLOW, (0, _constants2.getFollowErrorNotification)(name)), _defineProperty(_ERROR_ACTION_MAP, _constants2.ERROR_UNFOLLOW, (0, _constants2.getUnFollowErrorNotification)(name)), _defineProperty(_ERROR_ACTION_MAP, _constants2.ERROR_USER_INFO, _constants2.GET_USER_ERROR_NOTIFICATION), _defineProperty(_ERROR_ACTION_MAP, _constants2.ERROR_ORG_INFO, _constants2.GET_ORG_ERROR_NOTIFICATION), _ERROR_ACTION_MAP);
  return /*#__PURE__*/_react.default.createElement(NotificationBarContent, {
    dangerousContent: ERROR_ACTION_MAP[errorActionType]
  });
};

var NotificationBarContent = function NotificationBarContent(_ref3) {
  var dangerousContent = _ref3.dangerousContent;
  return (
    /*#__PURE__*/
    //eslint-disable-next-line react/no-danger
    _react.default.createElement("span", {
      className: "eds-text-bm",
      dangerouslySetInnerHTML: {
        __html: dangerousContent
      }
    })
  );
};

var FollowNotification = /*#__PURE__*/function (_PureComponent) {
  _inherits(FollowNotification, _PureComponent);

  var _super = _createSuper(FollowNotification);

  function FollowNotification(props) {
    var _this;

    _classCallCheck(this, FollowNotification);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_getTopOffset", function () {
      return _this.props.topOffset !== undefined ? _this.props.topOffset : _constants2.GLOBAL_NAV_HEIGHT;
    });

    _defineProperty(_assertThisInitialized(_this), "_updateHeight", function () {
      if (_dom.HAS_WINDOW) {
        var scrollDelta = Math.max(0, _this._getTopOffset() - window.pageYOffset);

        _this.setState({
          top: scrollDelta
        });
      }
    });

    _this.state = {
      top: _this._getTopOffset()
    };
    return _this;
  }

  _createClass(FollowNotification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var addEventListener = (0, _featureDetection.getWindowObject)('addEventListener');
      this._throttledHandler = (0, _throttle.default)(this._updateHeight, NOTIFICATION_BOUNCE_INTERVAL, {
        leading: true
      });
      addEventListener('scroll', this._throttledHandler);

      this._updateHeight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var removeEventListener = (0, _featureDetection.getWindowObject)('removeEventListener');

      if (removeEventListener) {
        removeEventListener('scroll', this._throttledHandler);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          hideNotification = _this$props.hideNotification,
          organizerName = _this$props.organizerName,
          errorActionType = _this$props.errorActionType,
          isNotificationShown = _this$props.isNotificationShown;
      var top = this.state.top;
      var isSuccessNotification = type === _constants.TYPE_NEUTRAL;
      return isNotificationShown && /*#__PURE__*/_react.default.createElement("div", {
        className: "following-notification eds-fx--fade-in-down",
        style: {
          top: "".concat(top, "px"),
          position: 'fixed',
          left: 0,
          width: '100%',
          zIndex: 10000,
          transition: '100ms'
        },
        "data-spec": "following-organizer-notification"
      }, /*#__PURE__*/_react.default.createElement(_NotificationBar.default, {
        type: type,
        isHidden: false,
        iconType: isSuccessNotification ? /*#__PURE__*/_react.default.createElement(_Check.default, null) : /*#__PURE__*/_react.default.createElement(_AlertChunky.default, null),
        hasCloseButton: true,
        onClose: hideNotification
      }, isSuccessNotification ? /*#__PURE__*/_react.default.createElement(SuccessNotificationBarContent, {
        name: organizerName
      }) : /*#__PURE__*/_react.default.createElement(ErrorNotificationBarContent, {
        name: organizerName,
        errorActionType: errorActionType
      })));
    }
  }]);

  return FollowNotification;
}(_react.PureComponent);

_defineProperty(FollowNotification, "propTypes", {
  /*
   * Wether the notification should be shown or not
   */
  isNotificationShown: _propTypes.default.bool.isRequired,

  /*
   * Callback for when the notification is dismissed
   */
  hideNotification: _propTypes.default.func,

  /*
   * Type of notification to render
   */
  type: _propTypes.default.oneOf([_constants.TYPE_NEUTRAL, _constants.TYPE_ERROR]),

  /*
   * Name of the organizer that was followed
   */
  organizerName: _propTypes.default.string,

  /*
   * Error type to determine copy
   */
  errorActionType: _propTypes.default.string,

  /*
   * Offset with the top of its container
   */
  topOffset: _propTypes.default.number
});

_defineProperty(FollowNotification, "defaultProps", {
  type: 'neutral'
});

var _default = (0, _withNotificationControls.default)(FollowNotification);

exports.default = _default;
//# sourceMappingURL=FollowNotification.js.map